import { render, staticRenderFns } from "./SearchUserItem.vue?vue&type=template&id=b5e85598&scoped=true&"
import script from "./SearchUserItem.vue?vue&type=script&lang=ts&"
export * from "./SearchUserItem.vue?vue&type=script&lang=ts&"
import style0 from "./SearchUserItem.vue?vue&type=style&index=0&id=b5e85598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e85598",
  null
  
)

export default component.exports